import { Action, Reducer } from "redux";
import { CompanyTypeState, CompanyTypeTypes, CompanyTypeActionTypes } from "./companyTypeTypes";

export const INITIAL_STATE: CompanyTypeState = {
	companyType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},

	companyTypePublic: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const companyTypeReducer: Reducer<CompanyTypeState> = (state: CompanyTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as CompanyTypeActionTypes;
	switch (actionTypes.type) {
		case CompanyTypeTypes.GET_COMPANY_TYPE:
			return {
				...state,
				companyType: { ...state.companyType, isLoading: true },
			};
		case CompanyTypeTypes.SAVE_COMPANY_TYPE:
			return {
				...state,
				companyType: {
					...state.companyType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};

		case CompanyTypeTypes.GET_COMPANY_TYPE_PUBLIC:
			return {
				...state,
				companyTypePublic: { ...state.companyTypePublic, isLoading: true },
			};
		case CompanyTypeTypes.SAVE_COMPANY_TYPE_PUBLIC:
			return {
				...state,
				companyTypePublic: {
					...state.companyTypePublic,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CompanyTypeTypes.RESET_REDUCER_COMPANY_TYPE:
			return {
				...state,
				companyType: INITIAL_STATE.companyType,
			};

		default:
			return state;
	}
};

export default companyTypeReducer;
